<template>
  <div>
    <AssessorXRefTab/>
  </div>
</template>
<script>
import AssessorXRefTab from '../../../../components/tax/SpecialTaxItems/newTaxRoll/assessorXRef.vue';

export default {
  name: 'AssessorXRef',
  components: {
    AssessorXRefTab,
  },
};
</script>
